import {
  wrapperStyles,
  backgroundContain,
  backgroundCover,
  columnsWrapperStyles,
  singleColumnStyles,
  singleColumnTabletStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  socialMediaIconStyles,
  typoParagraph,
  typoHeader,
  typoHeaderMobile,
} from 'components/Templates/styles/Red/commonObjectsStyles';

import authorImg from 'components/Templates/globalAssets/speakers/speakerblank.jpg';

import wwwIcon from 'components/Templates/globalAssets/icons/icons_website.svg?url';
import facebookIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_facebook.svg?url';
import linkedinIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_linkedin.svg?url';
import twitterIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_twitter.svg?url';
import instagramIcon from 'components/Templates/globalAssets/icons/icons_socialmedia_instagram.svg?url';


/* eslint-disable */
export default
{
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color' : '{backgroundColor}',
      'padding-top' : '15rem',
      'padding-bottom' : '15rem',
      'font-family': '{secondaryFont}'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  sectionWrapper: {
    '0': {
      ...columnsWrapperStyles,
    'margin-bottom' : '10rem',
    'width': '100%',
    'display': 'flex',
    'flex-wrap': 'wrap',
    }
  },
  sectionDescriptionWrapper: {
    '0': {
      'display': 'block',
      'width': '45%',
      'margin-right' : 'auto',
    },
    '76_8' : {
      'width': '100%',
    }
  },
  sectionTitle: {
    '0': {
      ...singleColumnStyles,
      ...typoHeader,
    'margin-right' : '2rem',
    'margin-bottom' : '2rem',
    'color': '{primaryColor}',
    'width': '100%'
    },
    '76_8' : {
      ...singleColumnTabletStyles,
      ...typoHeaderMobile,
      'margin-bottom' : '2rem',
      'color': '{primaryColor}'
    },
  },
  paragraph: {
    '0': {
      ...typoParagraph,
      'float': 'left',
      'width': 'calc(100% - 3rem)',
      'margin-bottom' : '6rem',
    },
    '76_8' : {
      ...singleColumnTabletStyles,
      'margin-bottom' : '3rem'
    }
  },
  allMembersWrapper: {
    '0': {
      'margin-top': '0',
      'margin-right': 'auto',
      'margin-bottom': '0',
      'margin-left': 'auto',

      'overflow-x': 'auto',

    },
    '76_8' : {
      'margin-left': '0',
      'margin-right': '0',
    },
    '37_5' : {

    }
  },
  memberContainer: {
    '0': {
      ...backgroundContain,
      'background-color' : '{backgroundColor}',
      'background-repeat-x':'repeat',
      'display': 'flex',
      'flex-direction': 'column',
      'max-width' : '44rem',
      'margin-right' : '2rem',
      'margin-bottom' : '4rem',
      'min-width': '28rem',
      'float': 'left'
    },
    '76_8' : {
      'margin-bottom': '3rem',
      'flex-basis': '100%',
      'max-width' : '40rem',
    },
    '37_5' : {
      'max-width' : 'unset'
    }
  },
  memberDot: {
    '0': {
      'font-size': '1rem',
      'color': '{primaryColor}',
      'margin-right': '1rem',
    },
  },
  nameOne: {
    '0': {
      'font-size': '1.8rem',
      'display' : 'inline-block',
      'color' : '{textColor}',
      'margin-bottom': '0.5rem',
      'margin-top': '2rem',
    }
  },

  memberDescOne: {
    '0': {
      'display': 'inline-block',
      'margin-bottom': '1.5rem',
      'text-align': 'left',
      'width': 'fit-content',
      'color': '{secondaryTextColor}',
      'font-size': '1.8rem',
    }
  },
  memberAvatarOne: {
    '0': {
      ...backgroundCover,
      'background-position-y': 'center',
      'width': '100%',
      'height': '20rem',
      'display' : 'block',
      'position' : 'relative',
      'margin-bottom': '0.5rem',
      'background-image': `url(${authorImg})`,
    }
  },
  nameTwo: {
    '0': {
      'font-size': '1.8rem',
      'display' : 'inline-block',
      'color' : '{textColor}',
      'margin-bottom': '0.5rem',
      'margin-top': '2rem',
    }
  },
  memberDescTwo: {
    '0': {
      'display': 'inline-block',
      'margin-bottom': '1.5rem',
      'text-align': 'left',
      'width': 'fit-content',
      'color': '{secondaryTextColor}',
      'font-size': '1.8rem',
    }
  },
  memberAvatarTwo: {
    '0': {
      ...backgroundCover,
      'background-position-y': 'center',
      'width': '100%',
      'height': '20rem',
      'display' : 'block',
      'position' : 'relative',
      'margin-bottom': '0.5rem',
      'background-image': `url(${authorImg})`,
    }
  },
  contactHorizontalWrapper: {
    '0': {
      'display': 'flex',
      'align-items': 'center',
      'margin-bottom': '1rem'
    }
  },
  memberIconsOne: {
    '0': {
      'margin-top' : '1rem',
      'width' : '100%',
      'overflow' : 'hidden'
    },
  },
  memberEmailOne: {
    '0': {
      ...typoParagraph,
      'text-align': 'left',
      'font-size': '1.8rem',
    },
  },
  memberPhoneOne: {
    '0': {
      ...typoParagraph,
      'text-align': 'left',
      'font-size': '1.8rem',
    },
  },
  memberFacebookIconOne: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+facebookIcon+')',
    },
  },
  memberLinkedinIconOne: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+linkedinIcon+')',
    },
  },
  memberTwitterIconOne: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+twitterIcon+')',
    },
  },
  memberInstagramIconOne: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+instagramIcon+')',
    },
  },
  memberWWWIconOne: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'margin-left': 'auto',
      'background-color': '{iconBackgroundColor}',
      'background-image': 'url('+wwwIcon+')', //another color version of svg?
      
    },
  },
  memberEmailTwo: {
    '0': {
      ...typoParagraph,
      'text-align': 'left',
      'font-size': '1.8rem',
    },
  },
  memberPhoneTwo: {
    '0': {
      ...typoParagraph,
      'text-align': 'left',
      'font-size': '1.8rem',
    },
  },
  memberFacebookIconTwo: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+facebookIcon+')',
    },
  },
  memberLinkedinIconTwo: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+linkedinIcon+')',
    },
  },
  memberTwitterIconTwo: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+twitterIcon+')',
    },
  },
  memberInstagramIconTwo: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'background-image': 'url('+instagramIcon+')',
    },
  },
  memberWWWIconTwo: {
    '0': {
      ...socialMediaIconStyles,
      'float' : 'left',
      'margin-right' : '0.6rem',
      'margin-left': 'auto',
      'background-color': '{iconBackgroundColor}',
      'background-image': 'url('+wwwIcon+')', //another color version of svg?
      
    },
  },
};
